"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Configure = Configure;

var _useConfigure = require("../connectors/useConfigure");

function Configure(props) {
  (0, _useConfigure.useConfigure)(props, {
    $$widgetType: 'ais.configure'
  });
  return null;
}